// @flow
import React from 'react'

// components
import { FieldLabel } from '../../Components/'
import { Bool } from '../../Components/_formFields'

// types
import type { DefaultMiniAppProps } from './'
import Popover from '../../Core/Components/Popover'

type CheckboxEnableAppProps = DefaultMiniAppProps & {
  miniAppData: {
    valuePath: string,
    changeVisibilityFieldName: string,
  }
}

type CheckboxEnableAppState = {
  checkBoxValue: boolean,
}

export default class CheckboxEnableApp extends React.Component<CheckboxEnableAppProps, CheckboxEnableAppState> {
  static defaultProps = {
    isBackOffice: false,
  }

  state = {
    checkBoxValue: false
  }

  componentDidMount() {
    const { formData, miniAppData, onChangeFieldVisibility } = this.props
    const value = !!formData.getIn(miniAppData.valuePath.split('.'), false)
    this.handleOnChange(value)
    if (miniAppData && !value) {
      onChangeFieldVisibility(miniAppData.changeVisibilityFieldName, true)
    } else {
      onChangeFieldVisibility(miniAppData.changeVisibilityFieldName, false)
    }
  }

  handleOnChange = (value: boolean) => {
    const { onChangeFieldVisibility, miniAppData, formData, onChangeFormData } = this.props
    if (!value) {
      const changedFormData = formData.asMutable()
      delete changedFormData[miniAppData.changeVisibilityFieldName]
      onChangeFormData(changedFormData)
    } else {
      const changedFormData = formData.set(miniAppData.valuePath.split('.'), formData.getIn(miniAppData.valuePath.split('.'), ''))
      onChangeFormData(changedFormData)
    }
    this.setState({ checkBoxValue: value })
    onChangeFieldVisibility(miniAppData.changeVisibilityFieldName, !value)
  }

  render() {
    const { content, miniAppData, inputHelps } = this.props

    return ([
      <div className='form-group d-flex flex-row flex-wrap flex-sm-row align-items-center' key='CicEnableApp-content'>
        <div className='col-10 col-sm-3 order-0 order-sm-0 pt-sm-2 mt-sm-1 text-sm-right'>
          <FieldLabel
            id='CheckboxEnableApp'
            label={content.fieldNames[`${miniAppData.changeVisibilityFieldName}CheckAppLabel`]}
          />
        </div>
        <div className='col-12 col-sm-6 order-3 order-sm-0 offset-sm-1 my-2'>
          <Bool
            enabled
            id='CheckboxEnableApp'
            isPristine
            label={content.fieldNames[`${miniAppData.changeVisibilityFieldName}CheckAppLabel2`]}
            name='checkboxEnableApp'
            onChange={(value) => {
              this.handleOnChange(value)
            }}
            prefix=''
            validationErrors={{}}
            value={this.state.checkBoxValue}
          />
        </div>
        <div className='col-2 col-sm-2 order-0 order-sm-0 text-right'>
          {inputHelps && inputHelps.content &&
          <Popover
            content={inputHelps.content}
            id='IDCheckboxEnableApp'
            templateVariables={{}}
            title={inputHelps.title}
          />
          }
        </div>
      </div>
    ])
  }
}
